import axios from 'axios';

const UPTIME_API_URL = 'https://api.uptimerobot.com/v2/getMonitors';
const uptime = {
    async getMonitors(apikey, monitors) {
        // let name, url, model, status;
        let data;
        await axios.post(UPTIME_API_URL, {
            'api_key': apikey,
            'custom_uptime_ratios': '60',
            'format': "json",
            'logs': '1',
            monitors
        }, { timeout: 1e4 }).then(res => {
            data = res.data.monitors;
        }).catch(err => {
            err;
            data = false;
        })
        return data;
    }
}
//对停机的时间进行转换


export default uptime;